export default __webpack_public_path__ + "static/media/hero-background.c0e62b0a.jpg";